import React from 'react'
import { Card } from './index'
import { Link } from 'react-router-dom'

const List = ({data, uniform, bookmark}) => {
  return (
    <div className="flex flex-wrap -mx-2 lg:-mx-4">
      {
        data &&
        data.map((d, index) => {
          if (index > 0) {
            return (
              <div className="w-1/2 lg:w-1/3 px-2 lg:px-4 mb-4 lg:mb-8" key={index}>
                <Link to={`/program/${d.id}/detail`}>
                  <Card data={d} bookmark={bookmark}/>
                </Link>
              </div>
            )
          }

          return uniform === true ? (
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4 mb-4 lg:mb-8" key={index}>
              <Link to={`/program/${d.id}/detail`}>
                <Card data={d} bookmark={bookmark}/>
              </Link>
            </div>
          ) : (
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4 mb-4 lg:mb-8" key={index}>
              <Link to={`/program/${d.id}/detail`}>
                <Card data={d} bookmark={bookmark}/>
              </Link>
            </div>
          )
        })
      }
    </div>
  )
}

export { List }
